// Automatische hoogte voor ingesloten formulieren (Odoo-iframes).
// De Odoo-embedpagina laadt zelf de child-kant van open-iframe-resizer. Wij spreken hier
// hetzelfde (kleine) protocol aan de parent-kant:
//   parent → child : { type: "iframe-child-init" }            (handshake, herhaald tot antwoord)
//   child  → parent: { type: "iframe-resized", height, width } (bij init én bij elke inhoudswijziging)
// Eigen implementatie i.p.v. de npm-parent: die faalt op een cross-origin iframe die al
// geladen is vóór ons script start (geplakte embed-code zonder loading="lazy").
// Werkt op elke iframe in een `.embed-form`-wrapper of met [data-autoresize]. Embeds die het
// protocol niet kennen, antwoorden nooit en houden gewoon hun hoogte uit de code/classes.

const SELECTOR = ".embed-form iframe, iframe[data-autoresize]";
const RETRY_MS = 500;
const MAX_RETRIES = 120; // 1 minuut; daarna geven we op (geen resizer in de embed)

function watch(iframe) {
	let answered = false;
	let tries = 0;
	let timer = null;

	const onMessage = (e) => {
		if (e.source !== iframe.contentWindow) return;
		const d = e.data;
		if (!d || d.type !== "iframe-resized" || !(d.height > 0)) return;
		answered = true;
		clearTimeout(timer);
		iframe.style.height = `${Math.ceil(d.height)}px`;
	};
	window.addEventListener("message", onMessage);

	const ping = () => {
		if (answered) return;
		iframe.contentWindow?.postMessage({ type: "iframe-child-init" }, "*");
		if (++tries < MAX_RETRIES) timer = setTimeout(ping, RETRY_MS);
	};

	// Meteen proberen (iframe kan al geladen zijn) én opnieuw zodra hij (her)laadt.
	ping();
	iframe.addEventListener("load", () => {
		answered = false;
		tries = 0;
		clearTimeout(timer);
		ping();
	});
}

function init() {
	document.querySelectorAll(SELECTOR).forEach(watch);
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
